import { ChangeDetectionStrategy, Component, inject, input, output } from "@angular/core";
import { Router } from "@angular/router";
import { Enterprise } from "../../Services/gestion.service";
import { GreenActionButtonComponent } from "../green-action-button/green-action-button.component";

@Component({
    imports: [GreenActionButtonComponent],
    selector: "enterprise-selector",
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    @if (this.enterprises().length > 0) {
      <div
        class="w-full h-full overflow-none pb-32 md:pb-2 p-2 flex flex-col justify-center items-center bg-gris-4 z-20">
        <div
          class="bg-white w-full h-fit my-auto max-h-full max-w-[800px] rounded overflow-y-auto flex flex-col border border-gris-3">
          <p class="w-full p-4 pb-0 text-center fg-noir-2 font-bold text-lg">Sélection du lieu de consommation</p>
          <p class="w-full p-4 text-center fg-noir-2 font-medium">Veuillez sélectionner le point de consommation pour
            lequel
          vous souhaitez commander.</p>
          <div class="w-full p-2 grid grid-cols-1 md:grid-cols-2 gap-2">
            @for (e of this.enterprises(); track e.id) {
              <div
                (click)="this.selectEnterprise(e)"
                class="relative rounded border border-gris-3 bg-gris-4 hover:bg-vert-1 hover:text-white cursor-pointer p-2 flex relative transition">
                <div class="flex items-center justify-center px-4">
                  <svg class="icon w-6 h-6">
                    <use [attr.href]="'/assets/images/icons/icons.svg#écoles'"></use>
                  </svg>
                </div>
                <div class="flex-1 flex flex-col">
                  <p class="font-semibold flex gap-2 items-center px-4 pl-0">
                    {{ e.name }}
                    @if (e.isAcceptPayment) {
                      <span class="material-icons text-[1rem] ml-auto group">
                        euro
                        <div
                          class="absolute left-0 right-0 bottom-full font-semibold mb-1 hidden group-hover:flex p-2 text-center bg-vert-1 text-white rounded shadow">
                          <p class="mx-auto">
                            Ce restaurant accepte les paiements.
                          </p>
                        </div>
                      </span>
                    }
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    
    @if (this.enterprises().length === 0) {
      <div
        class="w-full h-full overflow-none pb-32 md:pb-2 p-2 flex flex-col justify-center items-center bg-gris-4 z-20">
        <div class="bg-white p-4 rounded-lg flex flex-col gap-2 border border-gris-3">
          <p class="mb-2 text-center text-lg font-bold">Aucun lieu de consommation disponible</p>
          <p class="mb-3 font-medium text-center text-sm text-gris-2">Aucun lieu de consommation n'est disponible. <br/>Veuillez contacter le restaurateur pour activer les lieux de consommation.</p>
          <mk-green-action-button class="mx-auto w-64 h-12" (click)="this.router.navigate(['/'])" [enabled]="true" [baseLabel]="'Retour aux restaurants'" [baseIcon]="'arrow_back'" />
        </div>
      </div>
    }
    `
})
export class EnterpriseSelectorComponent {
  protected readonly router = inject(Router);

  readonly enterprises = input.required<Enterprise[]>();

  readonly enterpriseSelected = output<Enterprise>();

  // L'auto-sélection quand une seule entreprise est disponible est gérée par le parent
  // (RestaurantSelectedMainPage) pour éviter d'afficher puis masquer ce sélecteur.
  selectEnterprise(enterprise: Enterprise) {
    this.enterpriseSelected.emit(enterprise);
  }
}
